import { render, staticRenderFns } from "./SettingGuidePop.vue?vue&type=template&id=5115158f&"
import script from "./SettingGuidePop.vue?vue&type=script&lang=ts&"
export * from "./SettingGuidePop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports